import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useLocation,useNavigate, Outlet } from 'react-router-dom';

import { setProject, clearProject, setIsLoading, setIsDeleted } from '../../obj/pscState'

import useAuthentication from '../../hooks/useAuthentication';
import useUserManagement from '../../hooks/useUserManagement'
import useGncHistory from '../../hooks/useGncHistory'
import NoAccess from '../psc/lib/NoAccess'

const PortfolioLayout = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isDeleted = pscState.isDeleted

    const { currentUser, updateUser } = useAuthentication();

    const { getHistory } = useGncHistory()
    
    const [noAccess, setNoAccess] = useState(false)

    const { 
        userHasProjectAccess,
        userHasProjectInformationAccess,
    } = useUserManagement()
    
    const setCurrentProject = (projectID) => {
        dispatch(setIsLoading(true))
        
        // Store current project
        fetch('/v0/account/set_current_project', {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ project_id: projectID })
        })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                updateUser(json.result)
            })
            .catch(error => console.log("Portfolio Set Current Project error", error))
        
        fetch('/v0/projects/' + projectID, { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if (json.error) {
                    // try again
                    console.log('Failed to load project', json.error)
                    setNoAccess(true)
                    dispatch(clearProject())
                    dispatch(setIsLoading(false))
                    return
                }
                dispatch(setProject(json.result))
                dispatch(setIsLoading(false))
            })
            .catch(error => console.log("Portfolio Get Project error", error))
    }
    
    const currentProjectID = useMemo(() => {
        // If we've switched to a different project, update the local stored project data
        const path = location.pathname
        const re = /\/portfolio\/(\d+)/
        const matches = path.match(re)
        return matches ? parseInt(matches[1], 10) : null
    }, [location.pathname])
    
    useEffect(() => {
        if( isDeleted ) {
            console.log('isDeleted, navigating to main')
            dispatch(clearProject())
            dispatch(setIsDeleted(false))
            navigate('/main', { replace: true })
            return
        }

        if( currentProjectID === null ) {
            if( location.pathname === '/portfolio/new/information' ) {
                console.log("Current project ID is null, but we're on the new project page, so we'll let it slide.")
                return
            }
            // This should be impossible. But it appears it's not.
            console.log("Current project ID is null", location.pathname, getHistory())
            setNoAccess(true)
        }
        else if( typeof(project) === 'undefined' || typeof(project.id) === 'undefined') {
            // Not sure why this has happened, but make sure project is loaded
            console.log("Portfolio: project is empty")
            setCurrentProject(currentProjectID)
        }
        else if( currentProjectID !== project.id ) {
            // We swapped projects. Load it up
            console.log("Portfolio: Changed project")
            setCurrentProject(currentProjectID)
        }
        else {
            // All is well
            setNoAccess(false)
            dispatch(setIsLoading(false))

            // It's possible the user only have access to Dashboard and Information.
            // If so, we should navigate them to the Dashboard.
            // But don't do this if they're already trying those urls
            const path = location.pathname
            if (!userHasProjectAccess(currentUser, project.id)) {
                if (userHasProjectInformationAccess(currentUser, project.id, project.project_type.name) && (path.includes('/dashboard') || path.includes('/information'))) {
                    // Then we're ok
                }
                else {
                    setNoAccess(true)
                }
            }
        }
    }, [project, location])
    
    if( noAccess ) {
        return (<NoAccess/>)
    }

    return (
        <Outlet />
    )
};

export default PortfolioLayout
